import { formatPrice } from '../../../../utils/formats';

import { AVAILABLE } from './availabilityTypes';

/**
 * Returns an object describing ticket prices, of "available" tickets, given a races array.
 */
export default (races = []) => {
  let currencyLabel = '';

  const availabilePrices = [].concat(
    ...races.filter(r => !!r.tickets).map((r) => {
      currencyLabel = r.tickets.currencyLabel; // Assumed to always be identical
      return r.tickets.tickets
        .filter(t => t.charityTickets !== true)
        .filter(t => t.availability.type === AVAILABLE)
        .map(t => t.discountPrice || t.rrp);
    }),
  );

  if (availabilePrices.length > 0) {
    const multiplePrices = [...new Set(availabilePrices)].length > 1;
    const pricesFrom = Math.min(...availabilePrices);
    const pricesTo = Math.max(...availabilePrices);

    return {
      fromFormatted: formatPrice(currencyLabel, pricesFrom),
      ...(multiplePrices && {
        toFormatted: formatPrice(currencyLabel, pricesTo),
      }),
    };
  }

  return null;
};



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/helpers/getAvailableTicketPrices.js